// extracted by mini-css-extract-plugin
module.exports = {"active":"Drawer_active__2KRUZ","inactive":"Drawer_inactive__OMJeX"};